import { connectRouter, routerMiddleware } from 'connected-react-router';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import * as Builds from './Builds';
import * as Languages from './Languages';
import * as Locales from './Locales';
import * as Namespaces from './Namespaces';
import * as Projects from './Projects';
import * as Translations from './Translations';
import * as Versions from './Versions';
import * as ApiApplications from './ApiApplications';

export default function configureStore(history, initialState) {
  const reducers = {
    builds: Builds.reducer,
    languages: Languages.reducer,
    locales: Locales.reducer,
    namespaces: Namespaces.reducer,
    projects: Projects.reducer,
    translations: Translations.reducer,
    versions: Versions.reducer,
    apiApplications: ApiApplications.reducer,
  };

  const middleware = [thunk, routerMiddleware(history)];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (
    isDevelopment &&
    typeof window !== 'undefined' &&
    window.devToolsExtension
  ) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history),
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
